import styled from "styled-components";

export const Fieldset = styled.fieldset`
    border: none;
    padding: 0;
    margin: 0;
`;
